// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.auth-container .auth-logo {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}
.auth-container .switch-auth {
  margin-top: 10px;
  text-align: end;
  margin-bottom: 10px;
}
.auth-container .switch-auth .switch-auth-button {
  background: none;
  border: none;
  color: var(--pmu-primary);
  cursor: pointer;
  font-weight: bold;
  text-decoration: underline;
  padding: 0;
}
.auth-container .switch-auth .switch-auth-button:hover {
  color: rgb(103.2727272727, 32.7272727273, 103.2727272727);
}
.auth-container .social-signin {
  display: flex;
  gap: 20px;
}
.auth-container .terms-text {
  margin-top: 20px;
  font-size: 12px;
  color: #666;
}
.auth-container .terms-text a {
  color: #800080;
  text-decoration: none;
}
.auth-container .terms-text a:hover {
  text-decoration: underline;
}

@media screen and (max-width: 768px) {
  .auth-container {
    padding: 20px;
  }
  .auth-container .switch-auth {
    margin-top: 20px;
  }
  .auth-container .social-signin {
    flex-direction: column;
    gap: 10px;
  }
  .auth-container .terms-text {
    margin-top: 30px;
    padding: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/authpage/authpage.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;AACJ;AAEE;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;AAAJ;AAEI;EACE,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,UAAA;AAAN;AAGI;EACE,yDAAA;AADN;AAKE;EACE,aAAA;EACA,SAAA;AAHJ;AAME;EACE,gBAAA;EACA,eAAA;EACA,WAAA;AAJJ;AAMI;EACE,cAAA;EACA,qBAAA;AAJN;AAMM;EACE,0BAAA;AAJR;;AAUA;EACE;IACE,aAAA;EAPF;EAQE;IACE,gBAAA;EANJ;EAQE;IACE,sBAAA;IACA,SAAA;EANJ;EAQE;IACE,gBAAA;IACA,aAAA;EANJ;AACF","sourcesContent":[".auth-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  .auth-logo {\n    margin-bottom: 20px;\n    display: flex;\n    justify-content: center;\n  }\n\n  .switch-auth {\n    margin-top: 10px;\n    text-align: end;\n    margin-bottom: 10px;\n\n    .switch-auth-button {\n      background: none;\n      border: none;\n      color: var(--pmu-primary);\n      cursor: pointer;\n      font-weight: bold;\n      text-decoration: underline;\n      padding: 0;\n    }\n\n    .switch-auth-button:hover {\n      color: darken(#8e2d8e, 10%);\n    }\n  }\n\n  .social-signin {\n    display: flex;\n    gap: 20px;\n  }\n\n  .terms-text {\n    margin-top: 20px;\n    font-size: 12px;\n    color: #666;\n\n    a {\n      color: #800080; // Purple link color\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .auth-container {\n    padding: 20px;\n    .switch-auth {\n      margin-top: 20px;\n    }\n    .social-signin {\n      flex-direction: column;\n      gap: 10px;\n    }\n    .terms-text {\n      margin-top: 30px;\n      padding: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
